// extracted by mini-css-extract-plugin
module.exports = {"root":"CardTemplate_root__1KW43","header":"CardTemplate_header__2nyYS"};